import {Model} from "./base/Model";
import {Collection} from "./base/Collection";
import { v4 as uuid } from "uuid";
import DateHelperClass from '@/helpers/DateHelper'    

export class InvoiceRow extends Model {
      key: string = "";
      invoice_type: string = "";
      invoice_type_name: string = "";
      description: string = "";
      amount: number = 0;
      price: number = 0;
      total_price: number = 0;
      vatrate_percentage: number = 0;
      vatrate_key: string = "";
      timeregistrations:Collection = new Collection();
      fixedPrice: boolean = false;
       
        constructor(data = null) {
            super(data);

            if(data) {
            Object.keys(data).map((item) => {
                if(this[item] != undefined) {
                    this[item] = data[item];
                }
            });
            }
        }      
        getData(fields = null, asModel = false) {
            let data = super.getData(fields, asModel);
            if(this.timeregistrations && this.timeregistrations.length > 0) {
                let selectedTimeRegistrations = this.timeregistrations.where("selected", true).get(true);
                
                data['timeregistrations'] = selectedTimeRegistrations.getData(); 
            }
            return data;
        }
        public setVatRate= (vatObj) => {
            if(vatObj && vatObj.key) {
                this.vatrate_percentage = parseFloat(vatObj.percentage);
                this.vatrate_key = vatObj.key;
                this.validate = true; 
            }
        }
        
        public calculate=() => {
            if(this.invoice_type == "1" || (this.invoice_type == "3" && this.fixedPrice)  ) {
                let totalPrice = this.price;
                if(this.price && this.amount != 0 && this.vatrate_percentage > 0) {
                    totalPrice = this.price * this.amount;
                    totalPrice = totalPrice;
                    this.total_price = parseFloat(totalPrice.toFixed(2)); 
                }
            }
            if(this.invoice_type == "3" && !this.fixedPrice) {
                let selectedTimeReg = this.timeregistrations.where('selected', true).get();
                
                let totalPriceItems = 0;
                selectedTimeReg.map( function(item, index) {
                    let min = DateHelperClass.getTotalminutes(item.hours, item.minutes);
                    let totalPrice = min * (item.price/60);
                    totalPriceItems += totalPrice; 
                    
                    
                })
                
                this.price = parseFloat(totalPriceItems.toFixed(2));
                this.total_price = parseFloat(totalPriceItems.toFixed(2));
                this.amount = 1;
                
            }
            

        }
        
        public getVatTotal=() => {
            let vatTotal = 0;
            let totalPrice = this.price * this.amount;
            vatTotal = (totalPrice/100 * this.vatrate_percentage);
            vatTotal = parseFloat(vatTotal.toFixed(2));
            
            return vatTotal;
        }
        
        public setFixedPrice=(fixedPrice) => {
            this.fixedPrice = fixedPrice;
            if(this.fixedPrice) {
                this.price = 0;
                this.amount = 1;
            } else {
                this.price = 0;
                this.amount = 0;
                this.calculate();
            }
            
        }
    }